const TvScreenActions = {
    UPDATE_VENDORS: 'UPDATE_VENDORS',
    UPDATE_ACTIVE: "UPDATE_ACTIVE"
}

export default TvScreenActions;